import {Checkbox, Space} from "antd";
import React from "react";

export const LanguagesGroup = (
    props: {
        languages: string[],
        onChange: (languages: string[]) => void
    }
) => {
    const langs = [
        "Russian",
        "English"
    ]

    return (
        <Space direction={'vertical'}>
            {langs.map((lang, index) => <div key={index.toString()}><Checkbox
                checked={props.languages.includes(lang)} key={lang}
                onChange={(e) => {
                    if (props.languages.length == 1 && !e.target.checked) return
                    let lngs = []
                    if (e.target.checked) {
                        lngs = [...props.languages, lang]
                    } else {
                        lngs = props.languages.filter((l) => l !== lang)
                    }
                    let l = lngs.sort((a, b) => langs.indexOf(a) < langs.indexOf(b) ? -1 : 1)
                    props.onChange(l)
                }}>{lang}</Checkbox></div>)}

        </Space>
    )
}